  import PropTypes from 'prop-types';
  import React from 'react';

  export const FilterGroup = ({ children }) => (
    <div className="d-sm-flx flx-dir-sm-c mb4-sm" style={{ gap: '4px' }}>
      {children}
    </div>
  );

  FilterGroup.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const FilterRow = ({ children }) => (
    <div className="d-sm-flx flx-dir-sm-c mb2-sm" style={{ gap: '4px' }}>
      {children}
    </div>
  );

  FilterRow.propTypes = {
    children: PropTypes.node.isRequired,
  };

  export default FilterRow;
